export default __webpack_public_path__ + "static/media/leads_logo.a36940bf.svg";